<template>
    <section id="content" class="gray-area">
        <div class="container">
            <!-- >>> 'BreadCrumbs' - Row -->
            <div class="row">
                <!-- >>> VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                <sdr-breadcrumbs active_item="fifth" :module="modulo"></sdr-breadcrumbs>
                <!-- <<< VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
            </div>
            <!-- <<< 'BreadCrumbs' - Row -->


            <!-- >>> 'Overview' - Row -->
            <div class="row">
                <div class="container shortcode travel-ideas">
                    <h1 class="idea-title" style="margin-bottom:20px;">
                        <span class="index">
                            <i class="soap-icon-arrow-right circle"></i>
                        </span>
                        {{ pleaseselectoverview[getCurrentLocale] }}
                    </h1>
                </div>


                <!-- >>>  Left Side: : 'Overview' -->
                <form @submit.prevent="onSubmit">
                    <div id="main" class="col-sms-6 col-sm-8 col-md-9">
                        <!-- >>> Booking Details -->
                        <div id="flight-features" class="tab-container">
                            <!-- >>> TabHeader:  -->
                            <ul class="tabs">
                                <li class="active">
                                    <a href="#flight-details" data-toggle="tab">{{ tab_flightdetails[getCurrentLocale] }}</a>
                                </li>
                            </ul>
                            <!-- <<< TabHeader:  -->

                            <!-- >>> Tab Content: -->
                            <div class="tab-content">
                                <!-- >>> Tab: 'flight-details' -->
                                <div class="tab-pane fade in active" id="flight-details">
                                    <!-- >>> 'Outward Flight' -->
                                    <div v-if="get_RebookingUsersSearchDataGetRebookingKey.idTicketOutwards.length > 0">
                                        <h2>{{ tab_header_flightdetailsoutward[getCurrentLocale] }}:</h2>
                                        <sdr-rebooking-bookingno-flightdetails :flight="get_RebookingGetRebookingKeyResults.outwardFlight" flightdirection="outward" :modulo="modulo" :mode="mode" whichcall="getrebookingkey"></sdr-rebooking-bookingno-flightdetails>
                                    </div>
                                    <!-- <<< 'Outward Flight' -->

                                    <!-- >>> 'Inbound Flight' -->
                                    <div v-if="get_RebookingUsersSearchDataGetRebookingKey.idTicketReturn.length > 0">
                                        <br /><hr style="border-top: 1px solid #fdb714;" /><br />
                                        <h2>{{ tab_header_flightdetailsreturn[getCurrentLocale] }}:</h2>
                                        <sdr-rebooking-bookingno-flightdetails :flight="get_RebookingGetRebookingKeyResults.inboundFlight" flightdirection="return" :modulo="modulo" :mode="mode" whichcall="getrebookingkey"></sdr-rebooking-bookingno-flightdetails>
                                    </div>
                                    <!-- <<< 'Inbound Flight' -->

                                    <!-- >>> Total::Total::Total -->
                                    <br />
                                    <button type="button" class="btn-large full-width totalbutton" style="cursor: initial; outline: none !important; outline-style: none !important; background: #FDB714;">
                                        {{ Number(get_RebookingGetRebookingTicketsTotal) | rndAmntRUAFWZ }}
                                        <br />
                                        <span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span>
                                    </button>
                                    <!-- <<< Total::Total::Total -->
                                </div>
                                <!-- <<< Tab: 'flight-details' -->
                            </div>
                            <!-- <<< Tab Content: -->
                        </div>
                        <!-- <<< Booking Details -->




                        <!-- >>> Payment Details -->
                        <br />
                        <div class="booking-information sdr-box">
                            <h2>{{ payment[getCurrentLocale] }}:</h2>
                            <dl class="term-description">
                                <dt>{{ payment_firstname[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.firstName }}</dd>
                                <dt>{{ payment_lastname[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.lastName }}</dd>
                                <dt>{{ payment_email[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.email }}</dd>
                                <dt>{{ payment_phone[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.phone }}</dd>
                                <dt>{{ payment_address[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.address }}</dd>
                                <dt>{{ payment_zipcode[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.zipCode }}</dd>
                                <dt>{{ payment_city[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.city }}</dd>
                                <dt>{{ payment_countrycode[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.countryCode }}</dd>
                            </dl>
                            <hr />
                            <h2>{{ paymentmethod[getCurrentLocale] }}:</h2>
                            <p>{{ forsecurity[getCurrentLocale] }}</p>
                            <br />
                            <p class="red-color" v-if="getBookingProcessBookingObject.payment.type !== 'OO'">
                                {{ paymentismadeby[getCurrentLocale] }}
                                {{ getBookingProcessBookingObject.payment.ccPayment !== undefined ? creditcard[getCurrentLocale] : null }}
                                {{ getBookingProcessBookingObject.payment.ddPayment !== undefined ? debit[getCurrentLocale] : null }}
                                {{ getBookingProcessBookingObject.payment.type === 'CS' ? cashpayment[getCurrentLocale] : null }}
                            .</p>
                        </div>
                        <!-- <<< Payment Details -->




                        <!-- >>> Confirm CheckBoxes -->
                        <br />
                        <div class="booking-section sdr-box">
                            <!-- >>> Payment: CheckBoxes to Confirm/Check -->
                            <div class="container shortcode travel-ideas">
                                <h2 class="idea-title red-color" style="margin-bottom:15px;">
                                    <span class="index" style="background: #D13E47;">
                                        <i class="soap-icon-notice circle"></i>
                                    </span>
                                    {{ pleaseconfirm[getCurrentLocale] }}:
                                </h2>
                            </div>
                            <div class="form-group">
                                <!-- >>> Confirm - ABB -->
                                <p-check class="p-svg p-round p-pulse" color="success" value="ABB" v-model="checkedBoxes" id="check">
                                    <!-- svg path -->
                                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                                        <path
                                            d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                            style="stroke: white;fill:white"
                                        />
                                    </svg>
                                </p-check>&nbsp;
                                <a href="#" v-on:click.prevent="call_getwebcomponent('ABB')">
                                    <span class="xskin-color" style="font-size: 1.0833em;" >{{ form_confirmabb_1[getCurrentLocale] }}</span>
                                </a>
                                <!-- <<< Confirm - ABB -->


                                <!-- >>> Confirm - AGB -->
                                <br />
                                <p-check class="p-svg p-round p-pulse" color="success" value="AGB" v-model="checkedBoxes" id="check">
                                    <!-- svg path -->
                                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                                        <path
                                            d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                            style="stroke: white;fill:white"
                                        />
                                    </svg>
                                </p-check>&nbsp;
                                <a href="#" v-on:click.prevent="call_getwebcomponent('AGB')">
                                    <span class="xskin-color" style="font-size: 1.0833em;" >{{ form_confirmagb_1[getCurrentLocale] }}</span>
                                </a>
                                <!-- <<< Confirm - ABB -->


                                <!-- >>> Confirm - Dangerous Goods -->
                                <br />
                                <p-check class="p-svg p-round p-pulse" color="success" value="PCP" v-model="checkedBoxes" id="check">
                                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                                        <path
                                            d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                            style="stroke: white;fill:white"
                                        />
                                    </svg>
                                </p-check>&nbsp;
                                <a href="#" v-on:click.prevent="call_getwebcomponent('PCP')">
                                    <span class="xskin-color" style="font-size: 1.0833em;" >{{ form_confirmdangerous_1[getCurrentLocale] }}</span>
                                </a>
                                <!-- <<< Confirm - Dangerous Goods -->


                                <!-- >>> Confirm - Privacy -->
                                <br />
                                <p-check class="p-svg p-round p-pulse" color="success" value="PRIVACY" v-model="checkedBoxes" id="check">
                                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                                        <path
                                            d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                            style="stroke: white;fill:white"
                                        />
                                    </svg>
                                </p-check>&nbsp;
                                <a href="#" v-on:click.prevent="call_getwebcomponent('PCPE')">
                                    <span class="xskin-color" style="font-size: 1.0833em;">{{ form_confirmprivacy_1[getCurrentLocale] }}</span>
                                </a>

                                <!-- <<< Confirm - Privacy -->


                                <!-- >>> Confirm - Charges for additional services -->
                                <br />
                                <p-check class="p-svg p-round p-pulse" color="success" value="ADDITIONAL" v-model="checkedBoxes" id="check">
                                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                                        <path
                                            d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                            style="stroke: white;fill:white"
                                        />
                                    </svg>
                                </p-check>&nbsp;
                                <a href="/infos-additional-services/#/additional-services" target="_new">
                                    <span class="xskin-color" style="font-size: 1.0833em;">{{ form_confirmadditional_1[getCurrentLocale] }}</span>
                                </a>
                                <!-- <<< Confirm - Charges for additional services -->
                            </div>
                            <!-- <<< Payment: CheckBoxes to Confirm/Check -->
                        </div>
                        <!-- <<< Confirm CheckBoxes -->



                        <!-- >>> Pay Buttons -->
                        <button type="submit" class="btn-large icon-check uppercase full-width sundairrebooking icon-check4" v-if="getFlagBookingOverviewIsReadyForProcess === true">{{ proceed[getCurrentLocale] }}</button>
                        <a class="button btn-large uppercase full-width silver" v-if="getFlagBookingOverviewIsReadyForProcess !== true">{{ proceed[getCurrentLocale] }}</a>
                        <!-- >>> Pay Buttons -->
                    </div>
                </form>
                <!-- <<<  Left Side: : 'Overview' -->


                <!-- >>>  Right Side: Sidebar, 'Overview' -->
                <div class="sidebar col-sms-6 col-sm-4 col-md-3">
                    <!-- >>> VueCmp - 'sdr-contact-box', 'Contact Box' -->
                    <sdr-contact-box></sdr-contact-box>
                    <!-- <<< VueCmp - 'sdr-contact-box', 'Contact Box' -->
                </div>
                <!-- <<<  Right Side: Sidebar, 'Overview' -->
            </div>
            <!-- <<< 'Overview' - Row -->
        </div>




        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal
            name="size-modal2"
            transition="nice-modal-fade"
            classes="demo-modal-class"
            :min-width="200"
            :min-height="200"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            xwidth="40%"
            height="auto"
            @before-open="beforeOpen"
            @opened="opened"
            @closed="closed"
            @before-close="beforeClose">
            <div class="size-modal2-content">
                <h2>{{ webcomponenttype }}</h2>
                <span v-if="sections.length > 1">
                    <div
                        class="toggle-container box"
                        id="accordion1"
                        v-for="(section, index) in sections"
                        :key="index"
                        style="margin-bottom:0px;"
                    >
                        <div class="panel style1">
                            <h4 class="panel-title">
                                <a
                                    class="collapsed"
                                    v-bind:href="'#acc1_' + index"
                                    data-toggle="collapse"
                                    data-parent="#accordion1"
                                >{{ section.title }}</a>
                            </h4>
                            <div class="panel-collapse collapse" v-bind:id="'acc1_' + index">
                                <div class="panel-content">
                                    <span v-html="section.content"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>

                <span v-if="sections.length === 1">
                    <div class="panel style1">
                        <span v-html="sections[0].content"></span>
                    </div>
                </span>
            </div>
        </modal>




        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal
            name="wirecard-modal"
            transition="nice-modal-fade"
            classes="demo-modal-class"
            :min-width="1000"
            :min-height="550"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            height="auto"
            :clickToClose="false"
            @before-open="beforeOpenWirecardModal"
            @opened="openedWirecardModal"
            @closed="closedWirecardModal"
            @before-close="beforeCloseWirecardModal">
            <div class="size-modal2-content">
                <h2>3D Secure</h2>

                <iframe name="output_frame" id="output_frame" width="100%" height="550" :src='OutputFrameSrc'></iframe>

                <form name="downloadForm" id="downloadForm" ref="hiddenForm" :action="AcsUrl" method="POST" target="output_frame">
                    <input type="hidden" name="PaReq" :value="PaReq" />
                    <input type="hidden" name="TermUrl" :value="TermUrl" />
                    <input type="hidden" name="MD" value="" />
                </form>
            </div>
        </modal>
    </section>
</template>

<script>
    import FlightDetails from '../../rebooking/pagecontent/BookingnoFlightDetails.vue';

    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import ContactBox from '../../shared/sidebar/ContactBox.vue';

    import axios from 'axios';
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'], // via: router/push
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-rebooking-bookingno-flightdetails': FlightDetails,
            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-contact-box': ContactBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                listpoint_agb: {
                    en: 'General Terms',
                    de: 'AGB',
                },
                listpoint_abb: {
                    en: 'Terms and Conditions',
                    de: 'ABB',
                },
                listpoint_pcp: {
                    en: 'Dangerous goods',
                    de: 'Gefährliche Gegenstände',
                },
                listpoint_impressum: {
                    en: 'Imprint',
                    de: 'Impressum',
                },
                listpoint_sec: {
                    en: 'Data Protection & Privacy',
                    de: 'Datenschutz',
                },
                pleaseselectoverview: {
                    en: 'Step 5: Please check again your details.',
                    de: 'Schritt 5: Bitte überprüfen Sie noch einmal Ihre Angaben.'
                },
                // >>> --------------------------
                outwardflight: {
                    en: 'Outward',
                    de: 'Hinflug'
                },
                returnflight: {
                    en: 'Return',
                    de: 'Rückflug'
                },
                tab_flightdetails: {
                    en: 'Your booking overview',
                    de: 'Ihre Buchungsübersicht'
                },
                tab_inflightfeatures: {
                    en: 'Inflight Features',
                    de: 'Funktionen an Bord'
                },
                tab_baggage: {
                    en: 'Baggage',
                    de: 'Gepäck'
                },
                tab_farerules: {
                    en: 'Fare Rules',
                    de: 'Tarifbestimmungen'
                },
                from: {
                    en: 'From',
                    de: 'Von'
                },
                to: {
                    en: 'to',
                    de: 'nach'
                },
                tab_header_flightdetails: {
                    en: 'Your flight and booking details for the outbound flight',
                    de: 'Ihre Flug- und Buchungsdetails zum Hinflug'
                },
                tab_header_flightdetailsreturn: {
                    en: 'Your flight and booking details for the inbound flight',
                    de: 'Ihre Flug- und Buchungsdetails zum Rückflug'
                },
                tab_header_inflightfeatures: {
                    en: 'For your well-being on board',
                    de: 'Für Ihr Wohlbefinden an Bord'
                },
                tab_header_farerulesforyourflight: {
                    en: 'Fare Rules for your Flight',
                    de: 'Tarifregeln für Ihren Flug'
                },
                // >>> --------------------------
                adult: {
                    en: 'Adult',
                    de: 'Erwachsener',
                },
                child: {
                    en: 'Child',
                    de: 'Kind',
                },
                infant: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                takeoff: {
                    en: 'Take off',
                    de: 'Abflug',
                },
                landing: {
                    en: 'Landing',
                    de: 'Ankunft',
                },
                // >>> --------------------------
                airline: {
                    en: 'Airline',
                    de: 'Airline',
                },
                flighttype: {
                    en: 'Flight Type',
                    de: 'Tarif',
                },
                cancellation: {
                    en: 'Cancellation',
                    de: 'Stornierung',
                },
                flightchange: {
                    en: 'Flight Change',
                    de: 'Umbuchung',
                },
                seatsandbaggage: {
                    en: 'Seats & Baggage',
                    de: 'Sitze & Gepäck',
                },
                extracharge: {
                    en: 'Extra Charge',
                    de: 'Aufpreis'
                },
                avgpers: {
                    en: 'AVG/PAX',
                    de: 'PRO PAX'
                },
                // >>> --------------------------
                mr: {
                    en: 'Mr',
                    de: 'Herr',
                },
                mrs: {
                    en: 'Mrs',
                    de: 'Frau',
                },
                chd: {
                    en: 'Child',
                    de: 'Kind',
                },
                inf: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                born: {
                    en: 'Born',
                    de: 'Geb. am',
                },
                // >>> --------------------------
                form_confirmabb_1 : {
                    en: 'By continuing, you agree to the Terms and Conditions.',
                    de: 'Ich habe die ABBs gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmagb_1 : {
                    en: 'I confirm that I am 18 years or older and I have read and agree to the General Terms.',
        de: 'Ich bestätige, dass ich 18 Jahre oder älter bin und ich habe die AGB gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmdangerous_1 : {
                    en: 'I have read the information on the carriage of dangerous goods and agree to it.',
                    de: 'Ich habe die Informationen zur Beförderung gefährlicher Gegenstände gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmprivacy_1 : {
                    en: 'I have read the privacy policy and agree to it.',
                    de: 'Ich habe die Datenschutzerklärung gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmadditional_1 : {
                    en: 'I have noted the charges for additional services and agree to it.',
                    de: 'Ich habe die Entgelte für Zusatzleistungen zur Kenntnis genommen und erkläre mich damit einverstanden.',
                },
                pleaseclickallcheckboxes : {
                    en: 'Please confirm all Checkboxes.',
                    de: 'Bitte bestätigen sie alle Checkboxen.',
                },
                // >>> --------------------------
                travelerinformation: {
                    en: 'Traveler Information',
                    de: 'Reisende Infos',
                },
                payment: {
                    en: 'Your Payment details',
                    de: 'Ihre Zahlungsdetails',
                },
                paymentmethod : {
                    en: 'Your Payment method',
                    de: 'Ihre Zahlungsmethode',
                },
                forsecurity: {
                    en: 'For security reasons we do not write out your complete payment data here.',
                    de: 'Aus Sicherheitsgründen schreiben wir hier Ihre kompletten Zahlungsdaten nicht aus.',
                },
                paymentismadeby : {
                    en: 'Payment is made by ',
                    de: 'Die Zahlung erfolgt durch ',
                },
                creditcard: {
                    en: 'Creditcard',
                    de: 'Kreditkarte',
                },
                debit: {
                    en: 'Direct Debit',
                    de: 'Überweisung',
                },

                cashpayment: {
                    en: 'Cash',
                    de: 'Barzahlung',
                },
                payment_firstname: {
                    en: 'FIRST NAME',
                    de: 'Vorname',
                },
                payment_lastname: {
                    en: 'LAST NAME',
                    de: 'Nachname',
                },
                payment_email: {
                    en: 'EMAIL ADDRESS',
                    de: 'E-Mail',
                },
                payment_phone: {
                    en: 'Phone',
                    de: 'Telefon',
                },
                payment_address: {
                    en: 'STREET ADDRESS AND NUMBER',
                    de: 'Adresse',
                },
                payment_zipcode: {
                    en: 'ZIP CODE',
                    de: 'PLZ',
                },
                payment_city: {
                    en: 'TOWN / CITY',
                    de: 'Wohnort',
                },
                payment_countrycode: {
                    en: 'COUNTRY',
                    de: 'Land',
                },
                // >>> --------------------------
                pleaseconfirm: {
                    en: 'Please confirm',
                    de: 'Bitte bestätigen Sie',
                },
                flightprice : {
                    en: 'Flight price',
                    de: 'Flugpreis',
                },
                tincludedtaxes: {
                    en: 'incl. Taxes, Fees & Surcharges',
                    de: 'inkl. Steuern, Gebühren & Zuschlägen',
                },
                total : {
                    en: 'Total',
                    de: 'Gesamt',
                },
                totaloutwardprice: {
                    en: 'Total Outward',
                    de: 'Gesamt Hinflug',
                },
                totalreturnprice: {
                    en: 'Total Return',
                    de: 'Gesamt Rückflug',
                },
                // >>> --------------------------
                inflightfeatures_wifi: {
                    en: 'WI_FI',
                    de: 'WI_FI',
                },
                inflightfeatures_entertainment: {
                    en: 'Entertainment',
                    de: 'Entertainment',
                },
                inflightfeatures_television: {
                    en: 'Television',
                    de: 'Fernsehen',
                },
                inflightfeatures_television: {
                    en: 'Television',
                    de: 'Fernsehen',
                },
                inflightfeatures_airconditioning: {
                    en: 'Air conditioning',
                    de: 'Klimatisierung',
                },
                inflightfeatures_drink: {
                    en: 'Drink',
                    de: 'Getränke',
                },
                inflightfeatures_drink: {
                    en: 'Drink',
                    de: 'Getränke',
                },
                inflightfeatures_games: {
                    en: 'Games',
                    de: 'Spiele',
                },
                inflightfeatures_coffee: {
                    en: 'coffee',
                    de: 'Kaffee',
                },
                inflightfeatures_wines: {
                    en: 'Wines',
                    de: 'Weine',
                },
                inflightfeatures_shopping: {
                    en: 'Shopping',
                    de: 'Shopping',
                },
                inflightfeatures_food: {
                    en: 'Food',
                    de: 'Essen',
                },
                inflightfeatures_comfort: {
                    en: 'Comfort',
                    de: 'Komfort',
                },
                inflightfeatures_magazines: {
                    en: 'Magazines',
                    de: 'Zeitschriften',
                },
                agencycommision: {
                    en: 'Your agency commision is: ',
                    de: 'Ihre Agentur-Provision ist: ',
                },
                // >>> --------------------------
                inthissection: {
                    en: "In this section you'll find information on baggage allowances, special equipment and sports items as well as restricted items. We've also included some tips to make your trip more enjoyable.",
                    de: 'In diesem Abschnitt finden Sie Informationen über Freigepäck, Sonderausstattungen und Sportartikel sowie eingeschränkte Gegenstände. Wir haben auch einige Tipps beigefügt, um Ihre Reise noch angenehmer zu gestalten.',
                },
                // >>> --------------------------
                proceed: {
                    en: 'BOOK WITH OBLIGATION TO PAY',
                    de: 'ZAHLUNGSPFLICHTIG BUCHEN',
                },
                threedsecurecancelled: {
                    en: '3D Secure Proceedure canceled.',
                    de: '3D Secure Vorgang abgebrochen.',
                },
                // >>> -------------------------- Modal WireCard
                AcsUrl: null,
                PaReq: null,
                TermUrl: null,
                OutputFrameSrc: null,
                // >>> --------------------------
                // currentLocale: 'de',
                // >>> -------------------------- Modal
                webcomponenttype: '', // ABB/FAQ aso.
                sections: [], // data
                // >>> --------------------------
                checkedBoxes: [],
                // >>> --------------------------
                bankaccount_holder: null,
                bankaccount_no: null,
                bankaccount_bankno: null,
                // >>> --------------------------
                // >>> --------------------------
                tab_header_flightdetailsoutward: {
                    en: 'Your flight and booking details for all outbound flights',
                    de: 'Ihre Flug- und Buchungsdetails zu allen Hinflügen'
                },
                tab_header_flightdetailsreturn: {
                    en: 'Your flight and booking details for all return flights',
                    de: 'Ihre Flug- und Buchungsdetails zu allen Rückflugen'
                },
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'getFlagBookingOverviewIsReadyForProcess',
                'getBookingProcessBookingObject',
                'getBookingFlightIdSelectedReturn', // got RET Flight?
                'getBookingCart', // Pax per Pax
                'getBookingCartOutwardTotal', // Summed up Outward ALL
                'getBookingCartReturnTotal', // Summed up Return ALL
                // >>> --------------------------
                'getServicesProcessBookingObject', // object fpr process booking
                'getFlagSharedAgencyLoggedIn', // Agency
                'getSharedAgencyLoginResultsAmountAndValue', // Agency (Parts)

                // >>> --------------------------
                'getRebookingOriginalBookingHasOutwardFlight',
                'getRebookingOriginalBookingHasReturnFlight',
                'get_RebookingGetRebookingKeyResults',
                'get_RebookingGetRebookingTicketsTotal',
                'get_RebookingUsersSearchDataGetRebookingKey',
                'get_RebookingUsersSearchDataBookingno',
                // >>> --------------------------
                'getBookingWireCardEnrollPaymentResults',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            checkedBoxes: function() {

                if (this.checkedBoxes.length === 5)  {
                    this.actn_FlagBookingOverviewIsReadyForProcess(true);
                } else {
                    this.actn_FlagBookingOverviewIsReadyForProcess(false);
                }

            } // eof checkedBoxes()

        }, // eof watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytoshowrebookingsconfirmation' ('Call done ...').
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> shared/overview/Overview.vue >>> created');
            eventBus.$on('readytoshowrebookingsconfirmation', this.onEmit_ReadyToShowConfirmation);

            eventBus.$on('readytoshowwirecardmodal', this.onEmit_ReadyToShowWireCardModal);
            // >>> Listener for iFrame ------------------------------
            window.addEventListener("message", me.onEmit_MessageFromIFrameWasPosted);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
		mounted: function () {

            let me = this;


            me.$toc('>>> shared/overview/Overview.vue >>> mounted');


        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> shared/overview/Overview.vue >>> beforeDestroy');
            window.removeEventListener("message", me.onEmit_MessageFromIFrameWasPosted);
            eventBus.$off('readytoshowrebookingsconfirmation', this.onEmit_ReadyToShowConfirmation);
            eventBus.$off('readytoshowwirecardmodal', this.onEmit_ReadyToShowWireCardModal);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_FlagBookingOverviewIsReadyForProcess',
                // >>> --------------------------
                'actn_setServicesProcessBookingResults', // confirmation results
                // >>> --------------------------
                'actn_call_processRebooking',
                'actn_call_wireCardEnrollPayment', // new: wirecard enrollment
            ]),


            /******************************************************************* 'ServiceCalls - Booking'
            * ServiceCalls: 'Booking'
            *******************************************************************/
            /*******************************************************************
            * Call::'/site/getwebcomponent/'
            *
            * Desc:
            * Note:
            *
            * @param {string} comptype (kind of Component)
            * @param
            * @return
            */
            call_getwebcomponent: function (comptype) {

                var me = this,
                    hdrs = '';


                me.$toc('>>> booking/overview/Overview.vue >>> call_getwebcomponent');
                // >>> 1. Builds Object ----------------------------------------
                const requestParamObject = {
                    name: comptype
                };

                // >>> #267, Translation ---------------------------------------
                if (comptype === 'ABB') {
                    this.webcomponenttype = this.listpoint_abb[this.getCurrentLocale];
                }  else if (comptype === 'AGB') {
                    this.webcomponenttype = this.listpoint_agb[this.getCurrentLocale];
                }  else if (comptype === 'PCP') {
                    this.webcomponenttype = this.listpoint_pcp[this.getCurrentLocale];
                }  else if (comptype === 'PCPE') {
                    this.webcomponenttype = this.listpoint_sec[this.getCurrentLocale];
                } else {
                    this.webcomponenttype = comptype; // remember
                }

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put('/site/getwebcomponent/', requestParamObject)
                    .then(function(response) { // 'OK'
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                 me.$modal.show('size-modal2', { data: response.data });

                                me.$vp_um();
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_getwebcomponent()




            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: 'Overview Form' gets (not really) submitted.
            * Note:
            *
            * @param {Object} submitEvent (Event)
            * @return
            */
            onSubmit: function(submitEvent) {

                let me = this,
                    myOverviewParams = {};


                me.$toc('>>> booking/overview/Overview.vue >>> onSubmit');
                if (this.modulo === 'rebooking') {
                    if (this.getBookingProcessBookingObject.payment.ccPayment !== undefined) { // creditcard yes    => enrollment
                        this.actn_call_wireCardEnrollPayment(this.createObjectForEnrollment());
                    }
                    if (this.getBookingProcessBookingObject.payment.ccPayment === undefined) { // creditcard no     => process
                        myOverviewParams = this.build_Params_Call_processRebooking();
                        this.actn_call_processRebooking(myOverviewParams);
                    }
                }

            }, // eof onSubmit()


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToShowConfirmation()
            *
            * Desc: Handle
            * Note:
            *
            */
            onEmit_ReadyToShowConfirmation: function() {

                let me = this,
                    options = {};


                me.$toc('>>> shared/overview/Overview.vue >>> onEmit_ReadyToShowConfirmation');
                // >>> Scroll Options ------------------------------------------
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };


                me.$router.push({ path: '/confirmation/' + me.modulo });
                setTimeout(function() {
                    me.$scrollTo('#scrollPointTop', 200, options);
                }, 300);

            }, // eo function onEmit_ReadyToShowConfirmation()


            /*******************************************************************
            * onEmit_ReadyToShowWireCardModal()
            *
            * Desc: New CC Payment Way. WireCard. Enrollment.
            * Note:
            * Note: https://test-booking2019-2.sundair.com
            *
            */
            onEmit_ReadyToShowWireCardModal: function() {

                let me = this;


                me.$toc('>>> shared/overview/Overview.vue >>> onEmit_ReadyToShowWireCardModal');
                me.$modal.show('wirecard-modal', { });

                if (this.getBookingWireCardEnrollPaymentResults.provider === "heidelpay") {
                    // gets set in: 'beforeOpenWirecardModal'
                    // this.$refs.outputFrame.src = this.getBookingWireCardEnrollPaymentResults.redirectUrl;
                }

                if(this.getBookingWireCardEnrollPaymentResults.provider === "wirecard") {
                    //submit
                    setTimeout(function() {
                        this.$refs.hiddenForm.submit();
                    }.bind(this), 500);
                }

            }, // eo function onEmit_ReadyToShowWireCardModal()


            /*******************************************************************
            * onEmit_MessageFromIFrameWasPosted()
            *
            * Desc: Handler for Event:postMessage (from iFrame)
            * Note:
            *
            * @param {Object} event (Event)
            */
            onEmit_MessageFromIFrameWasPosted: function(event) {

                let me = this;


                me.$toc('>>> shared/overview/Overview.vue >>> onEmit_MessageFromIFrameWasPosted');
                me.$modal.hide('wirecard-modal', {});
                if (event.data.status === 'OK') { // && event.origin === CONF_3DSECURE_ORIGIN
                    this.actn_call_processRebooking(this.createObjectForProcessCreditCard(event))
                }
                if (event.data.status === 'KO') { // && event.origin === CONF_3DSECURE_ORIGIN
                        if (event.data.statusReason !== null && event.data.statusReason.length > 0) {
                            me.$toasted.global.sdr_app_error({
                                message: event.data.statusReason[0].description
                            });
                        }
                        if (event.data.statusReason === null || event.data.statusReason.length === 0) {
                            me.$toasted.global.sdr_app_error({
                                message: this.threedsecurecancelled[this.getCurrentLocale]
                            });
                        }
                }

            }, // eo function onEmit_MessageFromIFrameWasPosted()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * createObjectForEnrollment()
            *
            * Desc: Build Payload Object for Enrollment Call.
            * Note:
            *
            * @return {Object}
            */
            createObjectForEnrollment: function (){

                var me = this,
                    myOverviewParams = {};


                me.$toc('>>> shared/overview/Overview.vue >>> createObjectForEnrollment');
                myOverviewParams = {...this.getBookingProcessBookingObject };

                delete myOverviewParams.bookingKeyCode;
                delete myOverviewParams.isReservation;
                delete myOverviewParams.passengers;
                delete myOverviewParams.voucherCodes;

                myOverviewParams.amount = parseFloat(this.get_RebookingGetRebookingTicketsTotal, 10);
                myOverviewParams.comment = null;
                myOverviewParams.currency = 'EUR';

                myOverviewParams.payment.ccPayment.idProfiledPaymentData = null;
                myOverviewParams.payment.ccPayment.refererIp = '129.12.12.12';
                myOverviewParams.payment.comments = null;
                myOverviewParams.payment.currencyCode = null;
                myOverviewParams.payment.ddPayment = null;
                myOverviewParams.payment.ndPayment = null;
                myOverviewParams.payment.refererIP = '129.12.12.12';

                if (myOverviewParams.payment.ccPayment.cc_brand === 'MASTER') {
                    myOverviewParams.payment.ccPayment.cc_brand = 'mastercard';
                }
                if (myOverviewParams.payment.ccPayment.cc_brand === 'VISA') {
                    myOverviewParams.payment.ccPayment.cc_brand = 'visa';
                }
                if (myOverviewParams.payment.ccPayment.cc_brand === 'AMEX') {
                    myOverviewParams.payment.ccPayment.cc_brand = 'amex';
                }


                return myOverviewParams;

            }, // eo function createObjectForEnrollment()


            /*******************************************************************
            * createObjectForProcess()
            *
            * Desc: Build Payload Object for Process Call. CC ONLY!
            * Note:
            *
            * @param {Object} event (Event)
            * @return {Object}
            */
            createObjectForProcessCreditCard: function (event){

                var me = this,
                    myOverviewParams = {};


                me.$toc('>>> shared/overview/Overview.vue >>> createObjectForProcessCreditCard');
                myOverviewParams = this.build_Params_Call_processRebooking();

                delete myOverviewParams.payment.ccPayment.cc_brand;
                delete myOverviewParams.payment.ccPayment.cc_cvc;
                delete myOverviewParams.payment.ccPayment.cc_expiry_month;
                delete myOverviewParams.payment.ccPayment.cc_expiry_year;
                delete myOverviewParams.payment.ccPayment.cc_holder;
                delete myOverviewParams.payment.ccPayment.cc_number;
                delete myOverviewParams.payment.ccPayment.idProfiledPaymentData;
                delete myOverviewParams.payment.ccPayment.refererIp;

                myOverviewParams.payment.ccPayment.transactionId = event.data.transactionId;


                return myOverviewParams;

            }, // eo function createObjectForProcessCreditCard()


            /*******************************************************************
            * build_Params_Call_processRebooking()
            *
            * Desc: Build Object for Call.
            * Note:
            *
            */
            build_Params_Call_processRebooking: function() {

                var me = this,
                    usersSearchData = this.get_RebookingUsersSearchDataBookingno,
                    params = {
                        customer: {},
                        identifier: {},
                        payment: this.getBookingProcessBookingObject.payment
                    };


                me.$toc('>>> shared/overview/Overview.vue >>> onSubmit');
                params.bookingKeyCode               = this.get_RebookingGetRebookingKeyResults.keycode;

                params.customer.address             = this.getBookingProcessBookingObject.customer.address;
                params.customer.city                = this.getBookingProcessBookingObject.customer.city;
                params.customer.companyName         = this.getBookingProcessBookingObject.customer.companyName;
                params.customer.countryCode         = this.getBookingProcessBookingObject.customer.countryCode;
                params.customer.email               = this.getBookingProcessBookingObject.customer.email;
                params.customer.firstName           = this.getBookingProcessBookingObject.customer.firstName;
                params.customer.lastName            = this.getBookingProcessBookingObject.customer.lastName;
                params.customer.location            = this.getBookingProcessBookingObject.customer.location;
                params.customer.mobile              = this.getBookingProcessBookingObject.customer.mobile;
                params.customer.phone               = this.getBookingProcessBookingObject.customer.phone;
                params.customer.salutation          = this.getBookingProcessBookingObject.customer.salutation;
                params.customer.zipCode             = this.getBookingProcessBookingObject.customer.zipCode;

                params.identifier.bookingCode       = usersSearchData.bookingCode;
                params.identifier.email             = usersSearchData.email;
                params.identifier.idInvoice         = usersSearchData.idInvoice;
                params.identifier.justIdInvoice     = usersSearchData.justIdInvoice;
                params.identifier.lastName          = usersSearchData.lastName;
                params.identifier.modify            = usersSearchData.modify;
                params.identifier.operatorBooking   = usersSearchData.operatorBooking;
                params.identifier.paxBirthDate      = usersSearchData.paxBirthDate;


                return params;

            }, // eo function build_Params_Call_processRebooking()




            /*******************************************************************
            * Modals:
            *******************************************************************/
            /*******************************************************************
            * Modal - Events - beforeOpen
            *
            * Desc:
            * Note: Catches 'data' Object from $modal.show.
            *
            */
            beforeOpen: function(event) {

                this.sections = event.params.data.sections;

            }, // eof beforeOpen()


            /*******************************************************************
            * Modal - Events - beforeClose
            *
            * Desc:
            * Note:
            *
            */
            beforeClose: function() {

                this.sections = [];

            }, // eof beforeClose()


            /*******************************************************************
            * Modal - Events - beforeOpen
            *
            * Desc: Catch up Params.
            * Note:
            *
            */
            beforeOpenWirecardModal: function(event) {

                if (this.getBookingWireCardEnrollPaymentResults.provider === "heidelpay") {
                    this.OutputFrameSrc = this.getBookingWireCardEnrollPaymentResults.redirectUrl;
                }

                if (this.getBookingWireCardEnrollPaymentResults.provider === "wirecard") {
                    this.AcsUrl = this.getBookingWireCardEnrollPaymentResults.threeD.acsUrl;
                    this.PaReq = this.getBookingWireCardEnrollPaymentResults.threeD.pareq;
                    this.TermUrl = this.getBookingWireCardEnrollPaymentResults.termUrl;
                }

            }, // eof beforeOpenWirecardModal()


            /*******************************************************************
            * Modal - Events - beforeClose
            *
            * Desc:
            * Note:
            *
            */
            beforeCloseWirecardModal: function() {

            }, // eof beforeCloseWirecardModal()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    #flight-details .flights {
        padding-bottom: 0px;
    }
    #flight-details .flights .first-flight .logo:after {
        bottom: 23px;
    }

    .totalbutton {
        padding-right: 7px;
        height: 43px;
        font-size: 1.6667em; /* 1.4167em, 1.1667em; 1.6667em */
        line-height: 15px;
        text-align: right;
        height: 57px;
    }
    dl.term-description dt {
        color: #9e4d84;
    }
    .tab-container ul.tabs li.active > a,
    .tab-container ul.tabs li:hover > a {
        color: #9e4d84;
    }

    /* Price Table */
    .cruise-itinerary td {
        line-height: 2.5em;
        border: 1px solid #f5f5f5;
    }
    .booking-details .other-details {
        background-color: #f5f5f5;
    }
    .booking-details .other-details .total-price-value {
        font-size: 1.9167em;
    }
    .total-price-value-small {
        color: #98ce44;
        font-size: 1.4em;
        text-align: right;
    }
    .booking-details .other-details dt,
    .booking-details .other-details dd {
        padding-top: 0.4em;
        padding-bottom: 0.4em;
    }

    .icon-box.style9 > i {
        background: #9e4d84;
    }

    .hotel-faqs .topics li.active,
    #flight-fare-rules .topics li.active {
        background: #9e4d84;
    }

    /* Modal */
    .size-modal2-content {
        padding: 10px;
        font-style: 13px;
        background-color: rgb(255, 255, 255);
        padding-right: 50px;
    }
    .v--modal-overlay[data-modal='size-modal2'] {
        background: rgba(0, 0, 0, 0.5);
        z-index: 555555 !important;
    }
    .demo-modal-class {
        border-radius: 5px;
        background: #f7f7f7;
        box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
    }

    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: '';
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #4a6e89;
    }

    .icon-check4 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check4:after {
        content: '';
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #FDB714;
    }



    /* a {
            color: rgb(119, 41, 85);
        } */

    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        h1 {
            font-size: 1.5em;
        }
        h2 {
            font-size: 1.4em;
        }
        button.btn-large,
        input[type='button'].button.btn-large,
        a.button.btn-large {
            font-size: 1em;
        }

        .booking-section {
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 20px;
            padding-left: 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/overview/Overview.vue